<template>
	<div class="ecommerce_product_select_category" >
		<a href="javascript:void(0);" class="btn btn-none-radius" v-if="categorylist" @click="onChangeCategory(category.id)" :class="{'btn-default': currentCategory != category.id , 'btn-primary' : currentCategory == category.id}" v-for="(category,index) in categorylist" :key="'category_'+index" style="margin-right:5px">{{category.name}}</a>
		
	</div>
</template>

<script>
import api from '@/api'

export default{
	props : ['value','selected'],
	data : function(){
		return {
			categorylist: this.value,
			currentCategory : null
		}
	},
	mounted : function(){
		// console.log(this.selected)
		if (this.selected == null || !Number.isInteger(this.selected)) {
			this.currentCategory = this.categorylist[0].id
		} else {
			this.currentCategory = this.selected
		}
		this.$emit('onChangeCategory',this.currentCategory)
	},
	methods : {
		onChangeCategory : function(index){
			let vm = this
			vm.currentCategory = index
			// console.log(vm.currentCategory)
			vm.$emit('onChangeCategory',vm.currentCategory)
		}
	},
	watch: {
		value: function(newVal, oldVal){
			let vm = this
			vm.categorylist = newVal
		},
		selected: function(newVal, oldVal){
			if(newVal == null || !Number.isInteger(this.selected)){
				this.currentCategory = this.categorylist[0].id
				this.$emit('onChangeCategory',this.currentCategory)
			} else{
				this.currentCategory = newVal
				this.$emit('onChangeCategory',this.currentCategory)
			}
		}
	}

}
</script>


// WEBPACK FOOTER //
// src/components/view/template/event/SelectCategory.vue